"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_code_blocks_1 = require("react-code-blocks");
exports.default = () => {
    const [parentSolutionA, setParentSolutionA] = React.useState([""]);
    const [parentSolutionB, setParentSolutionB] = React.useState([""]);
    const [mergedSolution, setMergedSolution] = React.useState([""]);
    const [childSolutionA, setChildSolutionA] = React.useState([""]);
    const [childSolutionB, setChildSolutionB] = React.useState([""]);
    function shuffleArray(unshuffled) {
        const shuffled = unshuffled
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
        return shuffled;
    }
    function newSetup() {
        const cities = [];
        for (let i = 0; i < 8; i++) {
            cities.push(`City${i + 1}`);
        }
        const pA = shuffleArray(cities).map((v) => v.toUpperCase());
        const pB = shuffleArray(cities).map((v) => v.toLowerCase());
        setParentSolutionA(pA);
        setParentSolutionB(pB);
        const merged = [];
        let lIdx = 0;
        let rIdx = 0;
        while (true) {
            if (lIdx >= pA.length && rIdx >= pB.length)
                break;
            if (lIdx >= pA.length) {
                merged.push(pB[rIdx]);
                rIdx++;
            }
            else if (rIdx >= pB.length) {
                merged.push(pA[lIdx]);
                lIdx++;
            }
            else {
                // Pick one:
                if (Math.random() < 0.5) {
                    merged.push(pB[rIdx]);
                    rIdx++;
                }
                else {
                    merged.push(pA[lIdx]);
                    lIdx++;
                }
            }
        }
        setMergedSolution(merged);
        // Break it up:
        const seen = new Set();
        const cA = [];
        const cB = [];
        for (let i = 0; i < merged.length; i++) {
            const v = merged[i];
            if (seen.has(v.toLowerCase())) {
                cB.push(v);
            }
            else {
                cA.push(v);
                seen.add(v.toLowerCase());
            }
        }
        setChildSolutionA(cA);
        setChildSolutionB(cB);
    }
    return (React.createElement("div", null,
        React.createElement("p", null,
            "While reading",
            " ",
            React.createElement("a", { href: "https://link.springer.com/chapter/10.1007/978-3-642-17310-3_2" }, "Julian Miller's book on Cartesian Genetic Programming"),
            " ",
            "I came across a new operation that I haven't heard of, and wanted to document it here."),
        React.createElement("p", null, "It's called \"Merging Crossover\" (or MOX), and was proposed by Anderson and Ashlock in \"Advances in Ordered Greed\"."),
        React.createElement("p", null, "Let's you are using genetic algorithms on a problem that requires a permutated solution (ie: a solution that requires all elements exactly once in any order). Like trying to find a travelling salesman solution that visits 8 cities, each exactly once, trying to minimize the total distance traveled."),
        React.createElement("p", null, "You can take 2 solutions:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Solution A: ${parentSolutionA.join(" ")}\nSolution B: ${parentSolutionB.join(" ")}` }),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                newSetup();
            }) }, "Reset Solutions"),
        React.createElement("p", null, "You randomly merge them together into a single big solution:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Merged: ${mergedSolution.join(" ")}` }),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                newSetup();
            }) }, "Reset Solutions"),
        React.createElement("p", null, "You then read it from left to right, putting the first occurance of a value in the first child, and the second occurance in the second child:"),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Child A: ${childSolutionA.join(" ")}\nChild B: ${childSolutionB.join(" ")}` }),
        React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                newSetup();
            }) }, "Reset Solutions"),
        React.createElement("p", null, "It's an interesting little trick that ensures that you end up with two valid solutions afterwards.")));
};
